import React from 'react';
import VideoCarousel from '../VideoCarousel/VideoCarousel';
import Strings from '../../../translations/strings';
import styles from './VideoCarouselContainer.module.css';
import { CommonDataConnection } from '@eway-crm/connector';
import { getLocalStorageItem, setLocalStorageItem } from '../../../helpers/localStorage';

export interface IFeaturedVideosResponse {
    [lang: string]: IFeaturedVideo[] | null;
}

interface IFeaturedVideo {
    Title: string;
    IframeUrl: string;
    ThumbnailUrl: string;
}

type TVideoCarouselContainerProps = {
    commonDataConnection: CommonDataConnection;
};

type TVideoCarouselContainerState = {
    openedVideoIndex: number | null;
    videos: IFeaturedVideosResponse | null;
};

const videosCacheKey = 'VideosCache';

class VideoCarouselContainer extends React.Component<TVideoCarouselContainerProps, TVideoCarouselContainerState> {
    constructor(props: TVideoCarouselContainerProps) {
        super(props);
        const videosCacheJson = getLocalStorageItem(videosCacheKey);
        let videos = null;
        if (!!videosCacheJson) {
            videos = videosCacheJson;
        }
        this.state = {
            openedVideoIndex: null,
            videos,
        };
    }

    private readonly openVideo = (index: number) => {
        this.setState({ openedVideoIndex: index });
    };

    private closeVideo = () => {
        this.setState({ openedVideoIndex: null });
    };

    componentDidMount() {
        this.props.commonDataConnection.callCommonDataApi('GetWelcomeFeaturedVideos', {}, (response: any) => {
            setLocalStorageItem(videosCacheKey, response);
            this.setState((prevState) => ({ videos: prevState.videos || response }));
        });
    }

    render() {
        return (
            <section className={styles.carouselWrap}>
                <h2 className={styles.title}>{Strings.components.videoCarousel.title}</h2>
                <VideoCarousel
                    {...this.state}
                    openVideo={this.openVideo}
                    closeVideo={this.closeVideo}
                    commonDataConnection={this.props.commonDataConnection}
                />
            </section>
        );
    }
}

export default VideoCarouselContainer;
